'use client';

import dynamic from 'next/dynamic';

const DraggableSnapshots = dynamic(
  () => import('./DraggableSnapshots')
);

export default DraggableSnapshots;
